import { Redirect, Router } from '@reach/router'
import { ErrorBoundary, Loading, NotFound, Splashscreen } from 'components'
import { css, styles } from 'helpers'
import React, { useEffect, useState } from 'react'
import Errors from './Errors'
import Launcher from './Launcher'

const Terminal = React.lazy(() =>
  import(/* webpackChunkName: "Terminal" */ './Terminal')
)
const Booking = React.lazy(() =>
  import(/* webpackChunkName: "Planning" */ './Booking')
)
const Staff = React.lazy(() =>
  import(/* webpackChunkName: "Staff" */ './Staff')
)
const CRM = React.lazy(() => import(/* webpackChunkName: "CRM" */ './Crm'))
const Loyalty = React.lazy(() =>
  import(/* webpackChunkName: "Loyalty" */ './Loyalty')
)
const NativeApps = React.lazy(() =>
  import(/* webpackChunkName: "NativeApps" */ './NativeApps')
)
const WebApps = React.lazy(() =>
  import(/* webpackChunkName: "WebApps" */ './WebApps')
)

function useScript(src) {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    if (src) {
      window.is_react = true
      const script = document.createElement('script')
      script.src = src
      script.type = 'text/javascript'
      script.async = true
      document.body.appendChild(script)
      script.onload = () => setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src])

  return isLoading
}

function Modules({ location }) {
  const isTest =
    location.href.includes('test-terminal') ||
    process.env.NODE_ENV === 'development'
  const environment = isTest ? 'test' : 'production'

  const isLoading = useScript(
    isTest
      ? 'https://test-launcher.billetten.dk/launcher.js'
      : 'https://launcher.billetten.dk/launcher.js'
  )

  return (
    <React.Fragment>
      <Splashscreen isOpen={isLoading} />
      {!isLoading && (
        <React.Fragment>
          <Router className={css({ flex: '0 !important' })}>
            <Launcher default environment={environment} />
          </Router>
          <ErrorBoundary>
            <div
              className={css({
                backgroundColor: styles.colors.backgroundGrey,
                flex: 1,
                display: 'flex',
                marginTop: isTest && 40,
                '@media only screen and (min-width: 0px) and (max-width: 1200px)': {
                  marginTop: 40 + (isTest ? 40 : 0)
                }
              })}
            >
              <React.Suspense fallback={<Loading />}>
                <Router>
                  <Redirect from="/" to="/terminal/overview" noThrow />
                  <Terminal path="terminal/*" />
                  <Booking path="booking/*" />
                  <Staff path="staff/*" />
                  <CRM path="crm/*" />
                  <Loyalty path="loyalty/*" />
                  <NativeApps path="nativeapps/*" />
                  <NotFound default />
                </Router>
              </React.Suspense>
            </div>
          </ErrorBoundary>
          <Errors />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default function App() {
  return (
    <React.Suspense fallback={<Loading />}>
      <Router
        className={css({
          height: '100%',
          flexDirection: 'row !important',
          position: 'relative'
        })}
      >
        <Modules path="/*" />
        <WebApps path="apps/*" />
      </Router>
    </React.Suspense>
  )
}
